export default __webpack_public_path__ + "static/media/Jefferson.48849aec.png";